import { RootState } from 'store';

const baseSelector = (state: RootState) => state.editClasses;

export const academyProjectDetailsModalStateSelector = (state: RootState) =>
  baseSelector(state).academyProjectDetailsModalState;

export const bulkUpdateSyncConfirmModalStateSelector = (state: RootState) =>
  baseSelector(state).bulkUpdateSyncConfirmModalState;

export const bulkUpdateSyncTypeSelector = (state: RootState) =>
  baseSelector(state).bulkUpdateSyncType;
